module.exports = __webpack_public_path__ + "img/y5.8f3afd7f.webp";